module.exports = __webpack_public_path__ + "static/media/landing-footer-darkblue.c5955557.webp";